window.addEventListener('load', function () {
  var headerSignInBtn = document.querySelector('.bstack-mm-main-link-sign-in'),
    headerFreeTrailBtn = document.querySelector('.bstack-mm-main-link-free-trial'),
    pageSlugName = window.location.pathname;

  pageSlugName = pageSlugName.replace(/^\/|\/$/g, '');
  pageSlugName = pageSlugName.split('/').join('-');

  if (headerSignInBtn) {
    headerSignInBtn.setAttribute('href', headerSignInBtn.href + '?ref=' + pageSlugName);
  }

  if (headerFreeTrailBtn) {
    headerFreeTrailBtn.setAttribute('href', headerFreeTrailBtn.href + '?ref=' + pageSlugName);
  }
});
